import Rest from '@/services/Rest'

export default class UploadImageService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/uploadedimages';

  /**
   * Return list of uploaded images
   * @return {*|Promise<any>}
   */
  list() {
    return this.get(`/`)
  }

  /**
   * Return max size for images
   * @return {*|Promise<any>}
   */
  maxsize() {
    return this.get(`/maxsize`)
  }

  /**
   * Request base64 for image preview
   * @param uri
   * @return {*|Promise<any>}
   */
  show(uri) {
    return this.get(`/show?uri=${uri}`)
  }

  /**
   * Upload an image on be
   * @param data
   * @return {*|Promise<any>}
   */
  upload(data){
    return this.post(`/`, data)
  }


}
